module.exports = __webpack_public_path__ + "img/19_79.e1a12688.png";